import PlayerVimeo from './PlayerVimeo'
import PlayerButton from './PlayerButton'
import PlayerLoader from './PlayerLoader'
import PlayerYoutube from './PlayerYoutube'

export default {
  PlayerVimeo,
  PlayerButton,
  PlayerLoader,
  PlayerYoutube,
}




// WEBPACK FOOTER //
// ./src/js/components/player/index.js